import { createFileRoute } from "@tanstack/react-router"
import { AdminHome } from "@/features/admin-home/AdminHome"

export const Route = createFileRoute("/")({
	component: AdminHome,
})
